import * as React from 'react';
import { useState, useEffect, useRef } from 'react';
import moment from "moment";
import { post, get, ajax } from "jquery";
import { useHistory } from 'react-router-dom';
import 'core-js/fn/string/includes';
import 'core-js/fn/object/assign';

import ElementMessage from '../../components/common/elementmessage';
import ContentTitle from '../../components/common/container/title';
import Button from '../../components/forms/button';
import * as CONST from '../../helpers/const';
import { isMobile } from 'react-device-detect';
import IAC0100Table from './iac0100-table';
import IAC0100Filter from './iac0100-filter';

import 'core-js/fn/string/includes';
import 'core-js/fn/object/assign';
import "react-datepicker/dist/react-datepicker.css";
import ja from "date-fns/locale/ja"; // the locale you want

import Translate from '../../components/common/translate';
import Utils from '../../helpers/utils';
import { set } from 'core-js/fn/dict';
const getTranslateValue = Utils.getTranslateValue;

const API = {
  GETCARTINFO: window.domainDir + "api/Facility/GetIryokikanInfo"
};

const IAC0100_Master = (props) => {
  let translate = useRef(null);
  let history = useHistory();

  const [functionAvailable, setFunctionAvailable] = useState(true);
  const [newTabletProducts, setNewTabletProducts] = useState([]); // only in modal display
  const [newProducts, setNewProducts] = useState([]);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [pageNo, setPageNo] = useState(1);
  const [sizePerPage, setSizePerPage] = useState(10);

  const [resultCount, setResultCount] = useState(0);
  const [hasSearched, setHasSearched] = useState(false);
  const [message, setMessage] = useState("");
  const [status, setStatus] = useState("");
  const [showResultTable, setShowResultTable] = useState(false);

  const [translateSuccess, setTranslateSuccess] = useState(false);

  useEffect(() => {
    $("#loading").fadeIn();
    clearMessage();
    setSelectedProducts(props.selectedProducts);
    setNewProducts(props.selectedProducts);
    if(props.isTablet) {
      let tabletList = [...props.selectedProducts].splice(0, sizePerPage);
      setNewTabletProducts(tabletList);
    }
    $("#loading").fadeOut();
  }, []);

  function onPageChange(pageNo, sizePerPage) {
    setPageNo(pageNo);
    setSizePerPage(sizePerPage);
  }

  function handleFacilitySelected(row) {
    const postal = row.PostalCode
        ? row.PostalCode.slice(0, 3) + "-" + row.PostalCode.slice(3)
        : "";

    const selectedFacility = {
        PostalCode: postal,
        Address: row.Address ? row.Todofuken + row.Address : "",
        FacilityName: row.FacilityName || "",
        PhoneNumber: row.PhoneNumber || "",
        Fax: row.Fax || "",
        Address1: row.Address || "",
        Todofuken: row.Todofuken || "",
    };

    try {
        // Get existing facility information from sessionStorage
        const raw = sessionStorage.getItem(CONST.SessionData.FACILITYINFO);
        const existingData = raw ? JSON.parse(raw) : {};

        // Update only the selected facility fields.
        // Other existing properties are preserved.
        const combinedData = {
            ...existingData,
            ...selectedFacility
        };

        sessionStorage.setItem(CONST.SessionData.FACILITYINFO,JSON.stringify(combinedData));

    } catch (e) { }

    clearMessage();
    history.push(`/Cart/ConfirmFacilityInfo`);
  }

  function handleProducts(products) {
    clearMessage();
    setNewProducts(products);
    if(props.isTablet) {
      let tabletList = [...products].splice(0, sizePerPage);
      setNewTabletProducts(tabletList);
    }
  }

  function handleTabletPaginationUpdate(source) {
    let newList = Utils.rebuildTabletList(source, pageNo, sizePerPage);
    setNewTabletProducts(newList);
  }
  
  function tabletPagination() {
    let newList = Utils.buildTabletList(newProducts, newTabletProducts, pageNo, sizePerPage);
    setNewTabletProducts(newList.list);
    setPageNo(newList.page);
  }

  function clearMessage() {
    setStatus("");
    setMessage("");
  }
  
  return (
    <Translate ref={translate} handlerLoad={setTranslateSuccess.bind(this, true)}>
      <ContentTitle active="#IAC0101" title={getTranslateValue(translate.current, "views.iac0101.facilityinfo" )} />
          <ElementMessage message={message} status={status} clearMessage={clearMessage.bind(this)} />
          {renderFacilityInfoForm()}
          <IAC0100Filter
            getTranslateValue={getTranslateValue.bind(this)}
            translate={translate}
            GetCartInfoUrl={API.GETCARTINFO}
            setNewProducts={handleProducts.bind(this)}
            setResultCount={setResultCount}
            setHasSearched={setHasSearched}
            setMessage={setMessage}
            setStatus={setStatus}
            clearMessage={() => setMessage("")}
            setShowResultTable={setShowResultTable.bind(this)}
          />
          {showResultTable && renderTable()}
          {renderFormActions()}
    </Translate>
  )

  function renderFacilityInfoForm() {
    return (
      <div>
        <legend className="legend-hdr" style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 12, marginBottom: 30 }}>
          {/* <span>{getTranslateValue(translate.current, "views.iac0101.searchconditions")}</span>
          <span style={{ fontWeight: 'normal', fontSize: 12, color: '#666' }}>{getTranslateValue(translate.current, "views.iac0101.info1")}</span> */}
           <span style={{ flexBasis: '100%' }}>{getTranslateValue(translate.current, "views.iac0101.searchconditioninfo")}</span> {/*this should be on new line  */}
           <span style={{ flexBasis: '100%' }}>{getTranslateValue(translate.current, "views.iac0101.searchconditioninfo2")}</span> {/*this should be on new line  */}
        </legend>
      </div>
    );
  }
  
  function renderTable() {
    return (
      <div className="col-sm-12" style={props.isTablet ? {paddingTop:"10px", paddingBottom:"10px"} : {}}>
        <IAC0100Table
          data={props.isTablet ? newTabletProducts : newProducts}
          pageNo={pageNo}
          sizePerPage={sizePerPage}
          setSizePerPage={setSizePerPage}
          onPageChange={onPageChange.bind(this)}
          getTranslateValue={getTranslateValue.bind(this)}
          translate={translate}
          onSelectFacility={handleFacilitySelected.bind(this)}
          resultCount={resultCount}
          hasSearched={hasSearched}
        />
        {
          props.isTablet ? 
            newTabletProducts.length >= newProducts.length ? null
            :
            <div className="col-sm-12 col-md-12" style={{textAlign:"right", paddingTop:"10px", paddingRight:"0px"}}>
              <a style={{cursor:"pointer"}} onClick={() => tabletPagination()}>{getTranslateValue(translate.current, "views.table.tabletpagination")}</a>
            </div>
          : null
        }
      </div>
    );
  }
  function renderFormActions() {
    return (
      <div className="row form-group" style={{ marginTop: 10 }}>
        <div className="col-xs-4 text-left">
          <Button color="Default" divClassName="" divStyle={{ width: '100%' }} style={{ width: 140 }} label={getTranslateValue(translate.current, "views.iac0101.back")} onClick={() => {history.push(`/Cart/List`)}} />
        </div>
        <div className={isMobile ? "col-xs-8 text-right" : "col-xs-4 text-center"}>
        </div>
        {!isMobile && <div className="col-xs-4" />}
      </div>
    );
  }
}

export default IAC0100_Master;


// WEBPACK FOOTER //
// ./view/IAC0100/iac0100.jsx